"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var benefitsOptions = [
    'universal_credit',
    'jobseekers_allowance',
    'es_support',
    'income_support',
    'housing_benefit',
    'dla',
    'pip',
    'state_pension',
    'pension_credit',
    'attendance_allowance',
    'carers_allowance',
    'working_tax_credit',
    'child_tax_credit',
    'other',
    'none',
    'dont_know',
];
var BenefitsInReceiptInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var benefitsInReceipt = values.project.bget.benefits_in_receipt;
    return (react_1.default.createElement(__1.FormControl, { errors: ((_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.bget) === null || _b === void 0 ? void 0 : _b.benefits_in_receipt) || [], label: trans('project:slhh::labels.benefits-in-receipt'), showOther: benefitsInReceipt && benefitsInReceipt.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.bget) === null || _d === void 0 ? void 0 : _d.benefits_in_receipt_other, label: trans('project:slhh::labels.benefits-in-receipt-other') },
            react_1.default.createElement(__1.TextArea, { name: "project.bget.benefits_in_receipt_other", maxLength: 5000 })) },
        react_1.default.createElement("div", { className: "flex flex-col" }, benefitsOptions.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "benefits_in_receipt." + key, name: "project.bget.benefits_in_receipt", label: trans("project:slhh::enum.benefits-in-receipt." + key), value: key })); }))));
};
exports.default = BenefitsInReceiptInput;
//# sourceMappingURL=BenefitsInReceiptInput.js.map